import ScrollProgressIndicator from "./scrollProgressIndicator/ScrollProgressIndicator";

function App() {
    return <ScrollProgressIndicator />;
}

export default App;
